import { Injectable } from "@angular/core";
import { ModalController } from "@ionic/angular/standalone";
import { ImageViewerComponent } from "./image-viewer.component";

@Injectable({
    providedIn: 'root'
})
export class ImageViewerService {

    constructor(private modalController: ModalController) { }

    public async open(
        imageUrlArray: string[] | string, 
        autoBase: boolean = true, 
        initialImageIndex: number = 0,
        userName?: string,
        sidName?: string,
        photoName?: string
    ): Promise<void> {
        // Handle both array and single string input
        const images = Array.isArray(imageUrlArray) ? imageUrlArray : [imageUrlArray];
        
        const modal = await this.modalController.create({
            component: ImageViewerComponent,
            componentProps: {
                imageUrlArray: images,
                autoBase: autoBase,
                initialImageIndex: initialImageIndex,
                userName: userName || '',
                sidName: sidName || '',
                photoName: photoName || ''
            }
        });
        await modal.present();
    }
}